<template>
  <vue-final-modal
    :value="session.visible"
    name="eprint-dialog"
    :classes="['eprint-modal']"
    :styles="{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflowY: 'auto',
      padding: '20px'
    }"
    :content-class="['eprint-modal__content', 'v--modal-box', 'v--modal']"
    :click-to-close="false"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    :z-index-base="10000"
    @input="onVisibleInput"
    @opened="openApi.onDialogOpened"
  >
    <div ref="dialogRoot" class="eprint-modal">
      <div class="v--modal-close-top">
        <el-button
          icon="el-icon-circle-close"
          class="eprint-modal__close-btn"
          type="text"
          @click="openApi.closeDialog"
        />
      </div>
      <EprintCheckoutPanel
        v-if="session.eprintResultCode == '100' && isAuthenticated"
      />
      <EprintResultPanel v-if="session.eprintResultCode != '100'" />
      <div class="text-right">
        <el-button @click="openApi.closeDialog">閉じる</el-button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import EprintCheckoutPanel from '@/components/format-edit/eprint/EprintCheckoutPanel.vue'
import EprintResultPanel from '@/components/format-edit/eprint/EprintResultPanel.vue'
import { useEprintOpen } from '@/composables/format-edit/useEprintOpen'
import { useEprintPaypay } from '@/composables/format-edit/useEprintPaypay'
import { useEprintPaypayReturn } from '@/composables/format-edit/useEprintPaypayReturn'
import { useEprintPayment } from '@/composables/format-edit/useEprintPayment'
import { useEprintPdf } from '@/composables/format-edit/useEprintPdf'
import {
  provideEprintActions,
  provideEprintSession,
  type EprintActions
} from '@/composables/format-edit/useEprintSession'
import { useEprintStoreMap } from '@/composables/format-edit/useEprintStoreMap'

const session = provideEprintSession()
const actions = provideEprintActions({} as EprintActions)
const map = useEprintStoreMap(session)
const openApi = useEprintOpen(session, {
  cleanupMap: map.cleanupMap,
  stopPaypayRecheck: () => actions.stopPaypayRecheck(),
  searchNearCurrentLocation: map.searchNearCurrentLocation,
  completePaypayEprint: (id: string) => actions.completePaypayEprint(id)
})
const pdf = useEprintPdf(session, actions)
const payment = useEprintPayment(session, actions)
const paypay = useEprintPaypay(session, actions)
const paypayReturn = useEprintPaypayReturn(session, actions)
const { isAuthenticated } = openApi

Object.assign(actions, {
  openDialog: openApi.openDialog,
  closeDialog: openApi.closeDialog,
  onDialogOpened: openApi.onDialogOpened,
  scrollToTop: openApi.scrollToTop,
  changePaymentMethod: openApi.changePaymentMethod,
  eprintPDF2: pdf.eprintPDF2,
  eprintAtokakin: pdf.eprintAtokakin,
  handleSevenElevenClick: pdf.handleSevenElevenClick,
  handleCreditCardPaymentStart: payment.handleCreditCardPaymentStart,
  handlePaymentSuccess: payment.handlePaymentSuccess,
  handlePaymentError: payment.handlePaymentError,
  handlePaypayPayment: payment.handlePaypayPayment,
  handleEprintFailureRefund: payment.handleEprintFailureRefund,
  savePaymentLog: payment.savePaymentLog,
  updatePaymentLogStatus: payment.updatePaymentLogStatus,
  handleGetPaypayCodeEprint: paypay.handleGetPaypayCodeEprint,
  savePaypayEprintTempData: paypay.savePaypayEprintTempData,
  openPayPayEprintSite: paypay.openPayPayEprintSite,
  completePaypayEprint: paypayReturn.completePaypayEprint,
  stopPaypayRecheck: paypayReturn.stopPaypayRecheck,
  searchNearCurrentLocation: map.searchNearCurrentLocation,
  searchNearResumeAddress: map.searchNearResumeAddress,
  recenterToCurrentLocation: map.recenterToCurrentLocation,
  openMapAppNearCurrentLocation: map.openMapAppNearCurrentLocation,
  openMapAppNearResumeAddress: map.openMapAppNearResumeAddress,
  bindMapEl: map.bindMapEl,
  onQRCodeLoad() {},
  onQRCodeError() {},
  retryQRCode() {},
  handlePrintTypeChange() {},
  handleOtherSizesToggle() {},
  handleTermsLinkClick() {},
  dataChanged: openApi.dataChanged
})

const dialogRoot = ref<HTMLElement | null>(null)
watch(dialogRoot, (el) => {
  session.dialogRootEl = el
})

function onVisibleInput(value: boolean) {
  if (!value) openApi.closeDialog()
}
</script>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<style lang="scss" src="@/assets/scss/format-edit/eprint.scss"></style>
